import React from 'react';
import { howItWorksSteps } from '../data/mockData';
import { Calendar, MapPin, Package, Truck } from 'lucide-react';

const iconMap = {
  calendar: Calendar,
  location: MapPin,
  box: Package,
  truck: Truck
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <img 
            src="https://customer-assets.emergentagent.com/job_cenwi-dumpsters/artifacts/as0yrnig_ChatGPT%20Image%20Jan%2023%2C%202026%2C%2002_46_35%20PM.png" 
            alt="Dump Trailer Dude"
            className="h-16 w-auto mx-auto mb-4"
          />
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            How It Works
          </h2>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gray-200" style={{ width: '75%', marginLeft: '12.5%' }}></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorksSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={step.step} className="relative text-center group">
                  {/* Step Number */}
                  <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 -translate-y-full">
                    <span className="text-xs font-bold text-gray-400 tracking-wider">
                      STEP {step.step}
                    </span>
                  </div>
                  
                  {/* Icon Circle */}
                  <div className="relative inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#22C55E] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-10 h-10 text-white" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl font-bold text-[#22C55E] mb-4 uppercase tracking-wide italic">
                    {step.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-gray-600 text-sm leading-relaxed max-w-xs mx-auto">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Background Watermark */}
        <div className="mt-12 text-center">
          <span className="text-[200px] font-bold text-gray-100 select-none hidden lg:inline-block leading-none">
            TRAILERDUDE
          </span>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
